import React from 'react';
import Icon from '../../../components/AppIcon';
import useTranslation from '../../../hooks/useTranslation';
import useEscapeKey from '../../../hooks/useEscapeKey';
import DirectiveDocumentsPanel from './DirectiveDocumentsPanel';

/**
 * Pieces jointes d'une directive, dans une modale. Tout le contenu vient de
 * DirectiveDocumentsPanel, partage avec la modale Modifier.
 *
 * Les autres entites (extras, contrats, factures, DP, depenses) gardent
 * DocumentsModal et son listage Storage.
 */
const DirectiveDocumentsModal = ({ isOpen, onClose, directive, project, subtitle, onCountChange }) => {
  const { t } = useTranslation();

  // Le panneau intercepte Echap tant qu'un renommage ou une suppression est en cours.
  useEscapeKey(onClose, isOpen);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg flex flex-col max-h-[90vh] overflow-hidden" role="dialog" aria-modal="true">
        {/* En-tete */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-orange-50 flex items-center justify-center">
              <Icon name="FolderOpen" size={18} className="text-orange-600" />
            </div>
            <div className="min-w-0">
              <h2 className="text-sm font-semibold text-gray-900 leading-snug truncate">{t('documents.title')}</h2>
              {subtitle && <p className="text-[11px] text-gray-500 truncate">{subtitle}</p>}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors flex-shrink-0"
          >
            <Icon name="X" size={16} />
          </button>
        </div>

        {/* Pieces */}
        <div className="flex-1 overflow-y-auto px-5 py-4">
          <DirectiveDocumentsPanel
            directive={directive}
            project={project}
            active={isOpen}
            onCountChange={onCountChange}
          />
        </div>
      </div>
    </div>
  );
};

export default DirectiveDocumentsModal;
